.iconTile {
  align-items: center;
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
}

.filled span {
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
}

.sizeSmall {
  height: 48px;
  width: 48px;

  span {
    font-size: 24px;
    line-height: 24px;
  }
}

.sizeMedium {
  height: 60px;
  width: 60px;

  span {
    font-size: 44px;
    line-height: 44px;
  }
}

.tonePrimary {
  background-color: var(--pgm-sys-color-primary);
  color: var(--pgm-sys-color-on-primary);
}

.toneSecondary {
  background-color: var(--pgm-sys-color-secondary);
  color: var(--pgm-sys-color-on-secondary);
}

.toneTertiary {
  background-color: var(--pgm-sys-color-tertiary);
  color: var(--pgm-sys-color-on-tertiary);
}
